import {
  ACCCATEGORY_LOADING,
  GET_ACCCATEGORY,
  GET_ACCCATEGORY_SUCCESS,
  GET_ACCCATEGORY_FAIL,
  ADD_ACCCATEGORY_SUCCESS,
  ADD_ACCCATEGORY_FAIL,
  DELETE_ACCCATEGORY_SUCCESS,
  DELETE_ACCCATEGORY_FAIL,
  UPDATE_ACCCATEGORY_SUCCESS,
  UPDATE_ACCCATEGORY_FAIL,
  ACCCATEGORY_RESET
} from "./actionType";

const INIT_STATE = {
  accCategories: [],
  error: {},
};

const AccCategory = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ACCCATEGORY_SUCCESS:
      switch (action.payload.actionType) {
        case GET_ACCCATEGORY:
          return {
            ...state,
            accCategories: action.payload.data,
            isAccCategoryCreated: false,
            isAccCategorySuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_ACCCATEGORY_FAIL:
      switch (action.payload.actionType) {
        case GET_ACCCATEGORY_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isAccCategoryCreated: false,
            isAccCategorySuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_ACCCATEGORY: {
      return {
        ...state,
        isAccCategoryCreated: false,
        loading: true,
      };
    }

    case ACCCATEGORY_LOADING: {
      return {
        ...state,
        isAccCategoryCreated: false,
        loading: true,
      };
    }

    case ADD_ACCCATEGORY_SUCCESS:
      return {
        ...state,
        isAccCategoryCreated: true,
        loading: false,
        accCategories: [action.payload.data, ...state.accCategories],
      };

    case ADD_ACCCATEGORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_ACCCATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        isAccCategoryCreated: true,
        accCategories: state.accCategories.filter(
          accCategory => accCategory.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_ACCCATEGORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_ACCCATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        isAccCategoryCreated: true,
        accCategories: state.accCategories.map(accCategory =>
          accCategory.id.toString() === action.payload.data.id.toString() ? { ...accCategory, ...action.payload.data } : accCategory
        ),
      };

    case UPDATE_ACCCATEGORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ACCCATEGORY_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default AccCategory;